import { render, staticRenderFns } from "./data-ranking.vue?vue&type=template&id=9be3fb16&"
import script from "./data-ranking.vue?vue&type=script&lang=js&"
export * from "./data-ranking.vue?vue&type=script&lang=js&"
import style0 from "./data-ranking.vue?vue&type=style&index=0&id=9be3fb16&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports